import { useEffect, useRef, useId } from 'preact/hooks';

export default function Modal({ isOpen, title, size, onClose, children }) {
  const titleId = useId();
  const dialogRef = useRef(null);

  // Why: `onClose` is bij vrijwel elke aanroeper een inline arrow, die dus bij
  // iedere render van de ouder een nieuwe identiteit krijgt. Stond hij in de
  // deps hieronder, dan draaide het effect opnieuw zodra de ouder hertekende —
  // en trok `focus()` de cursor uit het veld waar iemand in zat te typen. De
  // Producten-view hertekent elke seconde om "3m geleden" bij te werken, dus
  // daar sprong de focus na elke letter weg. Via een ref blijft de handler
  // actueel zonder dat het effect eraan hangt.
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!isOpen) return;
    const handler = e => { if (e.key === 'Escape') onCloseRef.current(); };
    document.addEventListener('keydown', handler);
    // Why: initial focus naar de dialog zodat screenreaders de naam (via
    // aria-labelledby) aankondigen en toetsenbord-gebruikers er meteen in zitten.
    dialogRef.current?.focus();
    return () => document.removeEventListener('keydown', handler);
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div class="modal-overlay" onClick={e => { if (e.target === e.currentTarget) onClose(); }}>
      <div
        ref={dialogRef}
        class={`modal-content${size ? ` modal-content-${size}` : ''}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
      >
        <div class="modal-header">
          <h3 class="modal-title" id={titleId}>{title}</h3>
          <button type="button" class="modal-close" onClick={onClose} aria-label="Sluiten">&times;</button>
        </div>
        <div class="modal-body">{children}</div>
      </div>
    </div>
  );
}
